<nz-select
    style="width: 120px"
    nzSize="small"
    [ngModel]="(env$ | async)!"
    (ngModelChange)="onEnvChange($event)"
>
    <nz-option
        *ngFor="let opt of envOptions"
        [nzValue]="opt"
        [nzLabel]="opt"
    ></nz-option>
</nz-select>
